import { render, staticRenderFns } from "./GerenciamentoLog.vue?vue&type=template&id=3c2f9ec6"
import script from "./GerenciamentoLog.vue?vue&type=script&lang=js"
export * from "./GerenciamentoLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports